import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const MetricCard = ({ icon: Icon, title, value, subtitle, color }) => (
  <Card>
    <CardContent>
      <Box display="flex" alignItems="center" mb={2}>
        <Icon color={color} sx={{ mr: 1 }} />
        <Typography variant="h6">{title}</Typography>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="flex-start">
        <Typography variant="h4" color="text.primary">
          {value}
        </Typography>
        <Typography variant="subtitle2" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
    </CardContent>
  </Card>
);

export default MetricCard;
